import {
  ArticleImage,
  ArticleImageProps,
} from '@bonniernews/dn-design-system-web/assets/article-image/article-image.tsx'

import { formatClassString } from '@bonniernews/dn-design-system-web/helpers/formatClassString.ts'

/**
 * - GitHub: [BonnierNews/dn-design-system/web/src/components/article-top-image](https://github.com/BonnierNews/dn-design-system/tree/main/web/src/components/article-top-image)
 * - Storybook: [ArticleTopImage](https://designsystem.dn.se/?path=/docs/article-articletopimage--docs)
 *
 * The component will not include styling by itself. Make sure to include the right styles for the component. See example below:
 * `@use '@bonniernews/dn-design-system-web/components/article-top-image/article-top-image.scss'`
 */
export const ArticleTopImage = ({
  caption,
  imageType,
  author,
  image,
  forcePx,
  classNames,
  attributes,
}: ArticleImageProps) => {
  const classes = formatClassString(['ds-article-image--top', classNames])

  const imageParams = {
    fullWidth: true,
    caption,
    imageType,
    author,
    image,
    forcePx,
    classNames: classes,
    attributes,
  }

  return <ArticleImage {...imageParams} />
}
